<style lang="less" scoped>
@import '../../../style/common/variable';
.ImgArray{position: relative;width: 846px;height: 550px;padding: 0px;font-family: AlibabaPuHuiTi-Regular;}
ul {list-style: none;position: absolute;top: 0px;left: 0px;padding: 0px;height: 550px;overflow: hidden;}
li {margin-top: 22px;margin-right: 22px;width: 260px;height: 254px;float: left;background-color: #f0eeee;}
li:hover{cursor: pointer;p{color: #13569e;}}
.picBox{width: 260px;height: 160px;overflow: hidden;}
img{width: 260px;height: 160px;transition: transform .5s;}
img:hover {transform: scale(1.2,1.2)}
.titleBox{width: 260px;height: 55px;}
p{width: 250;height: 40px;text-align: left;margin: 6px 18px 16px 18px;font-size: 16px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;}
p{line-height: 20px;}
span{margin: 0px 20px 0px 170px;font-size: 10px;}
@media screen and (max-width: @max-screen){
  .imgArrayGN, .imgArrayGJ, .imgArrayDM{height: 7rem;
    ul{display: flex;flex-wrap: wrap;justify-content: space-around;align-items: center;width: 100vw;height: 7rem;
      li{width: 40vw;margin-top: 0;margin-right: 0; height: 2.2rem;
        span{margin: 0;}
      }
      .picBox{width: 40vw; height: 1.3rem;
        img{width: 40vw; height: 1.3rem}
      }
      .titleBox{width: 40vw;}
    }
  }
}
</style>

<!--何宽 矿业资讯首页展示一组图片-->
<template>
  <div class="ImgArray">
    <ul>
      <li v-for="(item,index) in imgArrayList" :key="index" @click="handleClick(item)">
        <div class="picBox">
          <img :src="item.pic" />
        </div>
        <div class="titleBox">
          <p> {{ item.title }} </p>
        </div>
        <span> {{ item.time * 1000 | formatDate()}} </span>
      </li>
    </ul>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  props: ['imgArrayList'],
  mixins: [filters],
  data()
  {
    return {}
  },
  methods: {
    // 点击 图片或标题， 将整个对象传递给父组件
    handleClick(item)
    {
      this.$emit('handleClick', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/ImgArray.vue